
import CapIcon from "../assets/imgs/Cap.png";
import { useContext, useEffect, useRef, useState } from "react";
import MyContext from "../context/MyContext";
import IconArrow90degLeft from "../assets/icons/icon";
import searchIcon from "../assets/icons/icons8-search.svg";
import { ScrollToTopButton } from "../utils/ScrollTop"
import CoffeData from "../../public/CoffeData.json";
import CoffeeBox from "../components/Elements/CoffeBox/CoffeBox";
import IconChevronBackOutline from "../assets/icons/Arrow";
import { Link } from "react-router-dom";
import "../style/SearchList.css"

interface DataFilter {
    id: number;
    name: string;
    category: string[];
    kind: {
        type: string;
        description: string;
        img: string;
    }[];
    price: string;
}

const SearchList = () => {

    const [state, setState] = useState<DataFilter[]>([]);
    const [Data, setData] = useState<DataFilter[]>([]);
    const [inputValue, setInputValue] = useState("");
    const [showUl, setShowUl] = useState(false);
    const [CoffeData, setCoffeData] = useState<any>([])

    const [dataCoffee, setDataCofee] = useState(
        JSON.parse(localStorage.getItem("DataCoffee") || "[]")
    );
    const { Refrch } = useContext(MyContext)!;
    const inputSearchFiled = useRef<any>(null);

    const handleSearch = (e: any) => {
        const value = e.target.value;
        setInputValue(value);
        setShowUl(value !== "");

        const filteredData = CoffeData.Data.filter(
            (coffe: any) =>
                coffe.name.includes(value) ||
                coffe.kind.some((coffee: any) => coffee.type.includes(value)) ||
                coffe.kind.some((coffe: any) => coffe.description.includes(value))
        );
        setState(filteredData);

    };

    const handleClickSearchValue = (name: string) => {
        const filteredData = CoffeData.Data.filter((coffe: any) =>
            coffe.name.includes(name)
        );
        setState(filteredData);
        setData(filteredData)
        setInputValue(name);
        setShowUl(false);
        ScrollToTopButton();
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        setData(state)
        setShowUl(false);
        ScrollToTopButton();
        if (inputValue === "") {
            setData([])
        }
        inputSearchFiled.current.blur();
    };

    useEffect(() => {
        setDataCofee(JSON.parse(localStorage.getItem("DataCoffee") || "[]"));
    }, [Refrch]);
    useEffect(() => {
        try {
            fetch('./CoffeData.json')
                .then(respone => respone.json())
                .then(data => setCoffeData(data))
        } catch {
            console.log("erorr")
        }
    }, [])

    return (
        <section className="search " >
            <div className="search_content">
                <form onSubmit={handleSubmit}>
                    <div className="back"><Link to={"../"}><IconChevronBackOutline /></Link></div>

                    <div className="input_group">
                        <label htmlFor="name" onClick={handleSubmit}>
                            <img src={searchIcon} alt="Search Icon" />
                        </label>
                        <input
                            ref={inputSearchFiled}
                            value={inputValue}
                            onChange={handleSearch}
                            id="name"
                            placeholder="ابحث عن طلبك"
                            type="text"
                        />
                        <ul style={{ display: showUl && state.length > 0 ? "block" : "none" }}>
                            {state.length > 0 && inputValue !== ""
                                ? (state.map((ele) => (
                                    <li key={ele.id} onClick={() => handleClickSearchValue(ele.name)}>
                                        {ele.name} <IconArrow90degLeft />
                                    </li>
                                ))
                                )
                                : undefined}
                        </ul>
                        

                    </div>
                    <div className="icon">
                        {/* <img src={shopIcon} alt="Shop Icon" />
          <span className={dataCoffee.length ? "dataFound" : ""}></span> */}
                    </div>
                </form>
                <>
                    {Data.length ? (
                        <div className="box-content ">
                            {Data.map((coffeeBox: any, index: any) => (
                                <CoffeeBox FilterCoffeeData={state} key={index} data={coffeeBox} />
                            ))}
                        </div>
                    ) : <img className="cap_pic" src={CapIcon} alt="" />}
                </>
            </div>
        </section>
    )
}

export default SearchList
